import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem } from '@angular/material/menu';
import { FeatherModule } from 'angular-feather';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

import { UserIdentityComponent } from './user-identity/user-identity.component';
import { AuthenticationService } from '~/app/auth/authentication.service';
import { CompanyInfo } from '~/app/auth/BoabaasUserService';
import { MemberIdentity } from '@v2/core/security/models/memberidentity';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-user-button',
  templateUrl: './user-button.component.html',
  styleUrls: ['./user-button.component.scss'],
  imports: [
    MatMenuTrigger,
    FeatherModule,
    MatMenu,
    MatMenuContent,
    RouterLink,
    MatMenuItem,
    UserIdentityComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class UserButtonComponent {
  accounts: CompanyInfo[] | null = null;

  auth = inject(AuthenticationService);

  readonly activeIdentity$: Observable<MemberIdentity | null> = this.auth.boabaasUser$.pipe(
    map((user) => {
      const identities = user?.identities ?? [];
      return identities.find((i) => i.isActive) ?? identities[0] ?? null;
    }),
  );

  onLogout(): void {
    this.auth.logout();
  }
}
